const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return

  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => Promise.all(
      registrations.map((registration) => registration.unregister())
    ))
    .catch(() => null)

  if (!("caches" in window)) return

  caches
    .keys()
    .then((keys) => Promise.all(
      keys.map((key) => caches.delete(key))
    ))
    .catch(() => null)
}

const skipWaiting = () => null

const sw = {
  registerServiceWorker,
  skipWaiting
}

export default sw
